import { render, staticRenderFns } from "./StoresDistributionCard.vue?vue&type=template&id=1737c6bc&scoped=true"
import script from "./StoresDistributionCard.vue?vue&type=script&lang=js"
export * from "./StoresDistributionCard.vue?vue&type=script&lang=js"
import style0 from "./StoresDistributionCard.vue?vue&type=style&index=0&id=1737c6bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1737c6bc",
  null
  
)

export default component.exports